import { MapPinIcon, RectangleGroupIcon } from "@heroicons/react/24/outline";
import React from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useUser } from "../../user/utils/user";

import { useRoleClientSelection } from "../contexts/RoleClientSelectionContext";

const roleDisplayMap = {
  Data: {
    key: "common.startDataCollection",
    default: "Start Data Collection",
    icon: MapPinIcon,
  },
  Delineation: {
    key: "common.startDelineating",
    default: "Start Delineating Parcels",
    icon: RectangleGroupIcon,
  },
  Delineation2: {
    key: "common.startDelineating",
    default: "Start Delineating Parcels",
    icon: RectangleGroupIcon,
  },
  Landcover: {
    key: "common.startLandcover",
    default: "Start Marking Land Cover",
    icon: RectangleGroupIcon,
  },
  Landcover2: {
    key: "common.startLandcover",
    default: "Start Marking Land Cover",
    icon: RectangleGroupIcon,
  },
  Landcover3: {
    key: "common.startLandcover",
    default: "Start Marking Land Cover",
    icon: RectangleGroupIcon,
  },
  Landcover4: {
    key: "common.startLandcover",
    default: "Start fixing dynamic world",
    icon: RectangleGroupIcon,
  },
};

function RoleSelection({ t }) {
  const navigate = useNavigate();
  const { user } = useUser();
  const { setSelectedRole } = useRoleClientSelection();

  const roleClients = user?.user?.role_clients ?? [];

  const rolesWithClients = roleClients.reduce((acc, rc) => {
    const roleName = rc.role_name || "Unknown";
    if (!acc[roleName]) {
      acc[roleName] = [];
    }
    acc[roleName].push(rc);
    return acc;
  }, {});

  const uniqueRoles = Object.keys(rolesWithClients);

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
    navigate("/clients");
  };

  if (uniqueRoles.length === 0) {
    return (
      <div className="text-center">
        <h1 className="text-xl font-semibold text-gray-900">
          {t("roleSelection.noRoles", "No roles available")}
        </h1>
        <p className="mt-4 text-gray-600">
          {t(
            "roleSelection.contactAdmin",
            "Please contact an administrator for access.",
          )}
        </p>
      </div>
    );
  }

  return (
    <div className="text-center">
      <h1 className="text-xl font-semibold text-gray-900">
        {t("roleSelection.selectRole", "Select Your Role")}
      </h1>
      <p className="mt-2 text-gray-600">
        {t(
          "roleSelection.chooseRole",
          "Choose the role you want to work with.",
        )}
      </p>
      <div className="mt-6 flex flex-col items-center space-y-4 max-w-md mx-auto">
        {uniqueRoles.map((role) => {
          const displayInfo = roleDisplayMap[role] || {
            key: role,
            default: role,
            icon: null,
          };
          const Icon = displayInfo.icon;
          return (
            <button
              key={role}
              type="button"
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-cyan-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 w-full"
              onClick={() => handleRoleSelect(role)}
            >
              {Icon && (
                <Icon className="-ml-1 mr-3 h-5 w-5" aria-hidden="true" />
              )}
              {t(displayInfo.key, displayInfo.default)}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default withTranslation()(RoleSelection);
